import UpdateMeditationTranslationRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/UpdateMeditationTranslationRequest";

export default class MeditationTranslateViewModel {
    langCode?: string = '';
	name?: string = '';
	description?: string = '';
    constructor(obj?: Partial<MeditationTranslateViewModel>) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
    toServerModel(): UpdateMeditationTranslationRequest {
        const res = new UpdateMeditationTranslationRequest({
            Description: this.description,
            LangCode: this.langCode,
            Name: this.name,
            VoiceFiles: []
        });
        return res;
    }
}
